import { render, staticRenderFns } from "./MerchandiseHome.vue?vue&type=template&id=030dfde3&"
import script from "./MerchandiseHome.vue?vue&type=script&lang=js&"
export * from "./MerchandiseHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports